let __IS_SELLER__: boolean | undefined = undefined;

export function getIsCurrentUserSeller() {
  return __IS_SELLER__;
}

export function setIsCurrentUserSeller(value: boolean | undefined) {
  __IS_SELLER__ = value;
}
